class CampaignStatusDomainService {
    static get notStarted() {
        return 1;
    }
    static get active() {
        return 2;
    }
    static get done() {
        return 3;
    }
}
CampaignStatusDomainService.getColor = (statusId) => {
    switch (statusId) {
        case CampaignStatusDomainService.active:
            return "info";
        case CampaignStatusDomainService.done:
            return "success";
        case CampaignStatusDomainService.notStarted:
            return "secondary";
        default:
            return "";
    }
};
export default CampaignStatusDomainService;
